export enum Permission {
  ACCESO_METEO = '1000',
  ACCESO_INCENDIOS = '2000',
  ACCESO_SIMULADOR = '3000',
  ACCESO_CONTAMINACION = '4000',
  ACCESO_TRAFICO = '5000',
  ACCESO_ESTACIONES = '1100',
  ACCESO_MOSAICO = '1200',
  ACCESO_INFORME = '0100',
  ACCESO_INFORME_METEOROLOGICO = '1010',
  ACCESO_INFORME_OBSERVACION = '1040',
  ACCESO_INFORME_PLAN_NACIONAL = '1050',
  ACCESO_INFORME_FWI = '2010',
  ACCESO_METEOGRAMA = '1020',
  ACCESO_RADIOSONDEO = '1030',
  ACCESO_POPUP_VALORES_INFORME = '1003',
  ACCESO_BLUR = '0001',
  ACCESO_SIMPLIFICACION = '0002',
  ACCESO_GEOCODER = '0003',
  ACCESO_DESCARGA = '0004',
  ACCESO_MASCARA = '0005',
  ACCESO_EVENTOS_MAPA = '0006',
  ACCESO_CAPA_BRIGADAS = '0007',
  ACCESO_DECKGL_TRANSITIONS = '0008',
  ACCESO_GRUPOS_VARIABLES_PERSONALIZADAS = '1001',
  ACCESO_GRUPOS_VARIABLES_PERSONALIZADAS_INCENDIOS = '2002',
  ACCESO_DESCARGA_TIFF_METEO = '1002',
  ACCESO_DESCARGA_TIFF_INCENDIOS = '2003',
  ACCESO_COMPARACION = '1300',
  ACCESO_BULLETIN = '1400',
  ACCESO_CONFIGURADOR_BOLETINES = '6000',
  ACCESO_INFORME_WFA = '3010',
  ACCESO_INFORME_METEOGRAMA = '3020',
  ACCESO_FOC_ALERTS = '2100',
  ACCESO_FOC_ALERTS_PUBLISH = '2101',
  ACCESO_DESCARGA_MULTIMEDIA = '7000',
  ACCESO_INFORME_IGP = '3030',
  ACCESO_INFORME_EXTREMADURA = '1004',
  ACCESO_CONFIGURACION_MOSAICO = '1201',
  ACCESO_CROWN_FIRE = '3100',
  ACCESO_WIND_RESOLUTION = '3210',
  ACCESO_TENERIFE_WILDFIRE_OPERATIVITY = '3301',
  ACCESO_ICONS_MAP = '7000'
}
